import { Stack } from "@mui/material";
import React, { useContext } from "react";
import AccessInformationComponent from "../../../amenity-components/amenity-access-information";
import AvailableAmenitiesComponent from "../../../amenity-components/amenity-available-component";
import AmenityEvents from "../../../amenity-components/amenity-event";
import datastore from '../../../../store/hoa-datastore';
import { checkVisibility } from "../../../../utility/data-configurator-helper";

const AmenitiesComponent: React.FC<{ details: any }> = ({ details }) => {

	const isAmenityVisible = (type: string) => {
		if (Object.keys(datastore.selectedConfiguration).length === 0) {
			return true;
		}
		const dataConfigAmenities = datastore.selectedConfiguration["Amenities"];
		return checkVisibility(dataConfigAmenities, type);
	};

	return (
		<Stack m={3} gap={"30px"}>
			{isAmenityVisible("Show the added new available amenities") && (
				<AvailableAmenitiesComponent availableAmenities={details?.newAvailableAmenities} />
			)}
			{isAmenityVisible("Show the added access information") && (
				<AccessInformationComponent accessInformation={details?.accessInformation} />
			)}
			{isAmenityVisible("Show the added amenity events") && (
				<AmenityEvents amenityEvents={details?.amenityEvents} />
			)}
		</Stack>
	);
};

export default AmenitiesComponent;
